import React from "react";
import {
  FaAward,
  FaBalanceScale,
  FaGavel,
  FaChartBar,
  FaHandshake,
  FaShieldAlt,
} from "react-icons/fa";
import "../Aboutus/About-text.css";

const cardData = [
  {
    icon: <FaAward />,
    title: "EXCELLENCE IN ADVOCACY",
    text: "Recognized for delivering outstanding legal representation with a proven track record in high-profile cases.",
    image: "/at1.webp",
  },
  {
    icon: <FaBalanceScale />,
    title: "CONFIDENTIAL CONSULTATION",
    text: "We prioritize your privacy and provide discreet legal advice tailored to your unique circumstances.",
    image: "/at2.webp",
  },
  {
    icon: <FaGavel />,
    title: "COMPREHENSIVE LEGAL DEFENSE",
    text: "Defending your rights with passion and precision across civil, criminal, and corporate matters.",
    image: "/at3.webp",
  },
  {
    icon: <FaChartBar />,
    title: "AWARD-WINNING STRATEGY",
    text: "Our legal strategies are backed by years of experience and numerous industry accolades.",
    image: "/at4.webp",
  },
  {
    icon: <FaHandshake />,
    title: "TRUSTED CLIENT RELATIONSHIPS",
    text: "We build lasting partnerships based on integrity, clarity, and transparent communication.",
    image: "/at5.webp",
  },
  {
    icon: <FaShieldAlt />,
    title: "SECURE LEGAL PROTECTION",
    text: "Providing peace of mind through robust protection against legal risks and disputes.",
    image: "/at6.webp",
  },
];

const Abouttext = () => {
  return (
    <div className="about-section">
      <div className="about-top">
        <div className="about-left">
          <h1>We Serve Best Services</h1>
        </div>
        <div className="about-right">
          <p>
            At Lawyer Firm, we combine deep legal knowledge with a client-first
            philosophy to provide exceptional representation across various
            legal domains.
          </p>
          <p>
            Whether you're facing a complex litigation, seeking contract
            guidance, or in need of confidential advisory, we deliver results
            with professionalism, precision, and trust.
          </p>
        </div>
      </div>

      <div className="card-grid">
        {cardData.map((card, index) => (
          <div
            key={index}
            className={`card ${index % 2 === 0 ? "dark-overlay" : "light-overlay"}`}
            style={{ backgroundImage: `url(${card.image})` }}
          >
            <div className="overlay-content">
              <div className="iconn">{card.icon}</div>
              <h3>{card.title}</h3>
              <p>{card.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Abouttext;
